import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatDate = (date) => {
  const d = new Date(date);
  return `${d.toLocaleDateString("en-US", {
    day: "numeric",
  })} ${d.toLocaleDateString("en-US", {
    month: "short",
  })} ${d.toLocaleDateString("en-US", {
    year: "numeric",
  })}`;
};

export const findEarliestDate = (dates) => {
  // Convert the date strings to Date objects
  const dateObjects = dates.map((date) => new Date(date));

  // Find the earliest date
  const earliestDate = new Date(Math.min(...dateObjects));

  return earliestDate;
};

export const findLatestDate = (dates) => {
  // Convert the date strings to Date objects
  const dateObjects = dates.map((date) => new Date(date));

  // Find the earliest date
  const latestDate = new Date(Math.max(...dateObjects));

  return latestDate;
};

export const isBeforeOrSame = (date1, date2) => {
  return date1.isBefore(date2, "day") || date1.isSame(date2, "day");
};

export const isAfterOrSame = (date1, date2) => {
  return date1.isAfter(date2, "day") || date1.isSame(date2, "day");
};

export const toUTC = (datetime) => {
  return dayjs(datetime).add(-dayjs().utcOffset(), "minute");
};

export const toLocal = (datetime) => {
  return dayjs(datetime).add(dayjs().utcOffset(), "minute");
};
